<template>
  <div class="yxtbiz-comment">
    <div class="yxtbiz-comment__content" :class="{'yxtbiz-comment__content--hover': limited && showLimitedType === 'hover'}">
      <yxtf-input
          :disabled="disabled|| limited"
          class="yxtbiz-comment__input"
          :type="inputType"
          :rows="row"
          :resize="resize"
          :placeholder="placeholder"
          :maxlength="maxLength"
          show-word-limit
          :autosize="autosize"
          v-model="content">
        <template slot="textlimit">
           <span class="yxtbiz-comment__count"><span class="mr8" v-if="minLength && content.length < minLength">{{$t('pc_biz_comment_word_limit', [minLength])}}</span><span v-if="maxLength" :class="{'yxtbiz-comment__count--last': maxLength - content.length <= 5}">{{maxLength - content.length}}</span></span>
        </template>
      </yxtf-input>
      <div class="yxtbiz-comment__limited" v-show="limited">
        <slot name="limited"></slot>
      </div>
    </div>
    <div class="yxtbiz-comment__sub">
      <div class="mr20 yxtbiz-comment__rate" :class="{'yxtbiz-comment__rate--text': showRateText}" v-if="this.showRate">
        <yxtf-row type="flex" align="middle">
          <div>{{rateReadonly && rate ? $t('pc_biz_comment_rated') : $t('pc_biz_comment_rate_please')}}</div>
          <yxtf-rate
            :disabled="disabled || limited || rateReadonly"
            text-color="#757575"
            v-model="rate"
            :show-text="showRateText"
            :texts="rateTexts"
            void-icon-class="yxt-icon-star-on"
            void-color="#d9d9d9"
          ></yxtf-rate>
        </yxtf-row>
      </div>
      <div class="mr20" v-if="showImages">
        <comment-images ref="commentImages" :projName="projName" :disabled="disabled || limited" :uploadOptions="uploadOptions"></comment-images>
      </div>
      <template v-if="showAnonymous">
        <div class="mr20 yxtbiz-comment__anonymous hover-primary-6" v-if="isAnonymousComment === 2">
          <yxtf-checkbox :disabled="disabled || limited" v-model="isAnonymous" :true-label="2" :false-label="0">{{isReply ? $t('pc_biz_comment_nickname_reply'): $t('pc_biz_comment_nickname')}}</yxtf-checkbox>
        </div>
        <div class="mr20 yxtbiz-comment__anonymous hover-primary-6"  v-else>
          <yxtf-checkbox :disabled="disabled || limited" v-model="isAnonymous" :true-label="1" :false-label="0">{{isReply ? $t('pc_biz_comment_anonymous_reply'): $t('pc_biz_comment_anonymous')}}</yxtf-checkbox>
        </div>
      </template>
      <div class="mr20">
        <slot name="functions"></slot>
      </div>
      <div class="yxtbiz-comment__submit">
        <yxtf-button plain v-if="cancelBtn" :disabled="disabled || limited" @click="cancel">{{$t('pc_biz_comment_cancel')}}</yxtf-button>
        <yxtf-button type="primary" :disabled="submitDisabled" @click="submit" :loading="loading">{{$t('pc_biz_comment_submit')}}</yxtf-button>
      </div>
    </div>
  </div>
</template>

<script>
import CommentImages from './commentImages.vue';
import {
  FrontRow,
  FrontCheckbox,
  FrontRate,
  FrontInput,
  FrontButton
} from 'yxt-pc';
export default {
  name: 'YxtbizComment',
  components: {
    CommentImages,
    YxtfRow: FrontRow,
    YxtfCheckbox: FrontCheckbox,
    YxtfRate: FrontRate,
    YxtfInput: FrontInput,
    YxtfButton: FrontButton
  },
  props: {
    row: {
      default: 3,
      type: Number
    },
    inputType: {
      default: 'textarea',
      type: String
    },
    placeholder: {
      default: '',
      type: String
    },
    maxLength: {
      default: null,
      type: Number
    },
    minLength: {
      default: null,
      type: Number
    },
    disabled: {
      default: false,
      type: Boolean
    },
    showRate: {
      default: false,
      type: Boolean
    },
    showAnonymous: {
      default: false,
      type: Boolean
    },
    isAnonymousComment: {
      default: 0,
      type: Number
    },
    showImages: {
      default: false,
      type: Boolean
    },
    uploadOptions: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isReply: {
      default: false,
      type: Boolean
    },
    cancelBtn: {
      default: false,
      type: Boolean
    },
    rateReadonly: {
      default: false,
      type: Boolean
    },
    showRateText: {
      default: true,
      type: Boolean
    },
    limited: {
      default: false,
      type: Boolean
    },
    showLimitedType: {
      default: 'normal',
      type: String,
      validator: (value) => {
        return ['normal', 'hover'].indexOf(value) !== -1;
      }
    },
    dataRequired: {
      type: Object,
      default: () => {
        return {
          content: true
        };
      }
    },
    resize: {
      type: String,
      default: 'none'
    },
    autosize: {
      type: [Object, Boolean],
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    defaultData: {
      type: Object,
      default: (() => {
        return {};
      })
    },
    projName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      content: '',
      rate: 0,
      isAnonymous: 0,
      rateTexts: [
        this.$t('pc_biz_comment_rate_level1'),
        this.$t('pc_biz_comment_rate_level2'),
        this.$t('pc_biz_comment_rate_level3'),
        this.$t('pc_biz_comment_rate_level4'),
        this.$t('pc_biz_comment_rate_level5')
      ]
    };
  },
  computed: {
    submitDisabled() {
      if (this.disabled) {
        return true;
      }
      if (this.limited) {
        return true;
      }
      if (this.dataRequired.content) {
        if (this.content.length === 0) {
          return true;
        }
      }
      if (this.dataRequired.rate) {
        if (!this.rate) {
          return true;
        }
      }
      if (this.minLength && this.minLength > this.content.length) {
        return true;
      }
    }
  },
  methods: {
    // 过滤Xss攻击代码
    filterXss: function filterXss(text) {
      if (!text) {
        return '';
      }
      // 去掉script标签
      text = text.replace(/<script[\s\S]*?(<\/script>|\/>)/ig, '');
      // 去除on事件
      var onTagReg = /<[^>]*?( |\/)(on[\W\w]*?=([""'])?([^'""]+)([""'])?)[\S\s]*?>/ig;
      var onReg = /( |\/)on[\W\w]*?=([""'])?([^'""]+)([""'])?/ig;
      var onMatches = onTagReg.exec(text);
      while (onMatches) {
        text = text.replace(onMatches[0], onMatches[0].replace(onReg, ''));
        onMatches = onTagReg.exec(text);
      }
      // 去除非链接href
      var hrefReg = /<a[^>]*(href=([""']?([^'""]+)([""'])?))[\S\s]*?>/ig;
      var hrefMatches = hrefReg.exec(text);
      while (hrefMatches) {
        hrefMatches[3].indexOf('http') !== 0 && (text = text.replace(hrefMatches[0], hrefMatches[0].replace(hrefMatches[1], '')));
        hrefMatches = hrefReg.exec(text);
      }
      // 去除eval(...)和expression(...)
      text = text.replace(/(eval|expression)\(.*?\)/ig, '');

      return text;
    },
    getData() {
      let data = {content: this.filterXss(this.content)};
      if (this.showRate) {
        data.rate = this.rate;
      }
      if (this.showAnonymous) {
        data.anonymous = this.isAnonymous;
      }
      if (this.showImages && this.$refs.commentImages) {
        data.images = this.$refs.commentImages.getImages();
        data.isUploaded = this.checkUploadingStatus();
      }
      return data;
    },
    submit() {
      let data = this.getData();
      this.$emit('submit', data);
    },
    cancel() {
      this.$emit('cancel');
    },
    setData(v) {
      this.setContent(v.content);
      this.setRate(v.rate);
      this.setImages(v.images);
      this.setAnonymous(v.anonymous);
    },
    setContent(content) {
      this.content = content;
    },
    setRate(rate) {
      this.rate = rate;
    },
    setImages(images) {
      if (this.$refs.commentImages) {
        this.$refs.commentImages.setImages(images);
      }
    },
    setAnonymous(anonymous) {
      this.isAnonymous = anonymous;
    },
    clear() {
      this.setData({
        content: '',
        rate: 0,
        images: [],
        anonymous: 0
      });
      if (this.$refs.commentImages) {
        this.$refs.commentImages.closePop();
      }
    },
    checkUploadingStatus() {
      if (this.$refs.commentImages) {
        return this.$refs.commentImages.checkStatus();
      }
      return true;
    }
  },
  created() {
    if (this.defaultData) {
      if (this.defaultData.content) {
        this.setContent(this.defaultData.content);
      }
      if (this.defaultData.rate) {
        this.setRate(this.defaultData.rate);
      }
      if (this.defaultData.anonymous) {
        this.setAnonymous(this.defaultData.anonymous);
      }
      if (this.defaultData.images && this.defaultData.images.length) {
        this.setImages(this.defaultData.images);
      }
    }
  }
};
</script>
